/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ApiClient } from '../types/api/ApiClient';
import { SupportPlanRequest } from '../types/common/PlanSupport';
import { getApiEndpoint } from '../utils/getApiEndpoint';
import { apiClientFactory } from '../utils/http-client/apiClientFactory';
import { axiosInstanceFactory } from '../utils/http-client/axiosInstanceFactory';
import { axiosJwtTokenInterceptor, axiosUnauthorizedInterceptor } from '../utils/http-client/axiosInterceptors';

class SuperuserSupportPlanService {
  private api: ApiClient;

  constructor() {
    this.api = apiClientFactory(
      axiosInstanceFactory(
        { baseURL: getApiEndpoint() },
        [axiosJwtTokenInterceptor],
        [[undefined, axiosUnauthorizedInterceptor]],
      ),
    );
  }

  createSupportPlan = ({ data }: { data: SupportPlanRequest }) => {
    return this.api.post<object>('/support-plans', data);
  };

  editSupportPlan = ({ data, planId }: { planId: string; data: SupportPlanRequest }) => {
    return this.api.patch(`/support-plans/${planId}`, data);
  };

  deleteSupportPlan = ({ planId }: { planId: string }) => {
    return this.api.del(`/support-plans/${planId}`);
  };
}

export const SuperuserSupportPlanApiService = new SuperuserSupportPlanService();
